import React, {Fragment, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {configuracionFormAction27, obtenerDatosAntecedentes, obtenerDatosGrilla} from '../../store/actions/antecedentes-jud-acion'
import {obtenerDatosLlaves} from '../../store/actions/caso-general-action'
import {configuracionFormAction28, enviarAsignacion, obtenerComboZonas, obtenerDatosGestionCaso, obtenerTipoNotifica} from '../../store/actions/reasignar-responsable-action'
import Grilla from './grilla'
import Reasignar from './reasignarResponsble'
import {useFormik} from 'formik'
import {Form} from 'react-bootstrap'
import { Auth } from 'recupero-comunes'
import { LoadingComponent } from 'recupero-comunes'

const ReasignarResponsableModal = ({
    handleClose,
    idCaso,
    idImplicado,
    idOrganizacionCaso,
    tipoGestion,
    ambitoGestion
}) => {
    const [loading, setLoading]=useState(false)
    const [isExtra, setIsExtra] = useState(false)
    const [isJudi, setIsJudi] = useState(false)
    const [idRespon, setIdRespon] = useState('')
    
    const [nombreRespon, setnombreRespon] = useState('')
    const [showToast, setShowToast] = useState(false);

    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const {llaves} = data_recepciona
    const data_reasignar = useSelector((state) => state.ReasignarResponsableReducer)
   const {datosGestionCaso} = data_reasignar
    const dispatch = useDispatch()
    const { rutUsuario, rutOrganizacion } = Auth.currentUser()
    useEffect(() => { 
       dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));

    }, [dispatch])
    useEffect(() => {
      if(llaves) { 
        setLoading(true)
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 28
        })).toString('base64')
        dispatch(configuracionFormAction28(query))
    .then(()=>{
        let query = Buffer.from(JSON.stringify({concepto: 224})).toString('base64')
        dispatch(obtenerComboZonas(query))
    })
    .then(()=>{
        let query = Buffer.from(JSON.stringify({
            idCaso: llaves && llaves["idCaso"],
            idImplicado: llaves && llaves["idImplicado"]
        })).toString('base64')
        dispatch(obtenerDatosGestionCaso(query))
    })
    .then(()=>{
        let query = Buffer.from(JSON.stringify({
            concepto: '264'
        })).toString('base64')
        dispatch(obtenerTipoNotifica(query))
    })
    .then(()=>{
        setLoading(false)
    })
    }
    }, [dispatch,llaves])

    const formik = useFormik({
        initialValues: {
            idCaso: '',
            idImplicadoCaso: '',
            idOrganizacion: '',
            siniestro: '',
            siniestroIM: '',
            patente: "",
            patenteIM: "",
            tipoGestion: "",
            idResponsable: "",
            responsable: "",
            modoAsignacion: "",
            observacion: "",
            idUsuario: ''
        },
        // validationSchema: validationSchemas(isModoContacto,isRespuestaContacto),
        onSubmit: (formData) => {
            const dataForm = {
                ...formData
            }
            setLoading(true)
            dataForm['idCaso'] = llaves && llaves['idCaso']
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
            dataForm['idUsuario'] = rutUsuario && rutUsuario
            dataForm['patente'] = datosGestionCaso && datosGestionCaso.datosGestionCaso[0]['patente']
            dataForm['siniestro'] = datosGestionCaso && datosGestionCaso.datosGestionCaso[0]['siniestro']
            dataForm['siniestroIM'] = datosGestionCaso && datosGestionCaso.datosGestionCaso[0]['siniestroIM']
            dataForm['patenteIM'] = datosGestionCaso && datosGestionCaso.datosGestionCaso[0]['patenteIM']
            dataForm['tipoGestion'] = datosGestionCaso && datosGestionCaso.datosGestionCaso[0]['codTipoGestion']
            dataForm['idResponsable'] = idRespon && idRespon
            dataForm['responsable'] = nombreRespon && nombreRespon
            dataForm['modoAsignacion'] = 218002
            
            //console.log("dataForm: ", dataForm);
            dispatch(enviarAsignacion(dataForm)).then(()=>setLoading(false))
            handleShowToast()
        }
    })

    return (
        <>
        <LoadingComponent show={loading}/>
            <Form onSubmit={
                formik.handleSubmit
            }>
                <Reasignar handleClose={handleClose}
                    formik={formik}
                    setIsExtra={setIsExtra}
                    isExtra={isExtra}
                    setIsJudi={setIsJudi}
                    isJudi={isJudi}/>
                <Grilla formik={formik}
                    isExtra={isExtra}
                    isJudi={isJudi}
                    setIdRespon={setIdRespon}
                    setnombreRespon={setnombreRespon}
                    setShowToast={setShowToast}
                     showToast={showToast}
                     handleClose={handleClose}
                    />
            </Form>
        </>
    )
}

export default ReasignarResponsableModal
